import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './NewsletterPage.scss';

export const NewsletterPage: FC = (): ReactElement => (
    <Page className="newsletter-page">
        <ConnectedPageHelmet appRoute={AppRoute.newsletter} />
        <ConnectedBlockRenderer appRoute={AppRoute.newsletter} />
    </Page>
);
